import React from 'react'
import Hero from './Hero';
import CrateTicket from './CreateTicket';


function SupportPage() {
    return ( 
        <>
            <Hero />
            <CrateTicket />
        </>
     );
}

export default SupportPage;